import { render } from "./RFIModal.vue?vue&type=template&id=582588fb"
import script from "./RFIModal.vue?vue&type=script&lang=js"
export * from "./RFIModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__